document.addEventListener('alpine:init', () => {
  Alpine.data('latamHero', () => ({
    animated: false,
    active: 'red',
    transitioning: false,

    init() {
      const colors = ['red', 'blue', 'turquoise', 'yellow'];
      let currentIndex = 0;

      setInterval(() => {
        currentIndex = (currentIndex + 1) % colors.length;
        this.active = colors[currentIndex];
        this.transitioning = true;
        setTimeout(() => (this.transitioning = false), 700);
      }, 2000);
    },

    animate() {
      this.animated = true;
    },
  }));
});